'use strict';

function NnNgRepeatFinishedDirective ($timeout) {

  'ngInject';

  return {
    restrict: 'A',
    link: function (scope) {
      if (scope.$last === true) {
        $timeout(function () {
          scope.$emit('ngRepeatFinished');
        });
      }
    }
  }
}

export default NnNgRepeatFinishedDirective



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-ng-repeat-finished.directive.js